// extracted by mini-css-extract-plugin
module.exports = {"component":"footer-background_component__4heXo"};